import { render, staticRenderFns } from "./MpaisModals.vue?vue&type=template&id=26e4cac7"
import script from "./MpaisModals.vue?vue&type=script&lang=js"
export * from "./MpaisModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports